import React from 'react';
import styled from 'styled-components';

const Wrap = styled.figure`
    margin: 8px 0;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    background: #f8fafc;
`;

const Img = styled.img`
    display: block;
    width: 100%;
    max-height: 220px;
    object-fit: cover;
    background: #eee;
`;

const Caption = styled.figcaption`
    font-size: 11px;
    color: #8c8c8c;
    padding: 4px 8px;
    background: #fafafa;
    border-top: 1px solid #f0f0f0;
    text-align: center;
    letter-spacing: 0.2px;

    a {
        color: inherit;
        text-decoration: underline;
    }
`;

/**
 * Renders a Wikipedia / Wikimedia Commons photo with required CC attribution.
 * Pass an item with at least { photo } and optionally { photoFile, photoAttribution, photoLicense }.
 */
export const ModalPhoto = ({ item, alt }) => {
    if (!item?.photo) return null;
    return (
        <Wrap>
            <Img src={item.photo} alt={alt || item.name || item.nazev || ''} loading="lazy" />
            {(item.photoAttribution || item.photoLicense) && (
                <Caption>
                    Foto: {item.photoAttribution || 'neuvedeno'}
                    {item.photoLicense ? ` • ${item.photoLicense}` : ''}
                    {item.photoFile && (
                        <>
                            {' • '}
                            <a
                                href={`https://commons.wikimedia.org/wiki/File:${item.photoFile}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Wikimedia Commons
                            </a>
                        </>
                    )}
                </Caption>
            )}
        </Wrap>
    );
};
